<template>
  <div class="unit-list">
    <Row :gutter="12">
      <Col :span="5">
        <Card>
          <Tree :data="unitList" :key="Math.random()" class="demo-tree-render" @on-select-change="treeChange"></Tree>
        </Card>
      </Col>
      <Col :span="19">
        <Card>
<!--          <div style="display: flex;flex-direction: row">-->
<!--            <div>-->
<!--              姓名：<Input type="text" v-model="formInline.user" placeholder="请输入姓名" style="width: 200px">-->
<!--            </Input>-->
<!--            </div>-->
<!--            <div style="margin-left: 8px">-->
<!--              单位：<Input type="text" v-model="formInline.unit" placeholder="请输入单位" style="width: 200px">-->
<!--            </Input>-->
<!--            </div>-->
<!--            <Button type="primary" @click="" style="margin-left: 8px">查询</Button>-->
<!--          </div>-->
          <div style="text-align: right;margin-top: 10px">
            <Button code="emergency.unit.add" type="primary" @click="gotoAdd" style="margin-left: 4px">新增</Button>
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>导入</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>导出</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>模版下载</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>批量删除</Button>-->
<!--            <Button type="primary" @click="" style="margin-left: 4px" disabled>批量维护</Button>-->
          </div>
          <div style="margin-top: 10px">
            <Table
                :loading="dataLoading"
                :columns="columns"
                :data="data"
                :border="false"
                :stripe="false"
                :highlight-current-row="true"
            >
              <template #action="{ row, index }">
                <el-button size="small" type="text" :disabled="row.workAddressBook.createUser !== curUserId" @click="editUnit(row)">编辑</el-button>
                <el-button size="small" type="text" :disabled="row.workAddressBook.createUser !== curUserId" @click="deleteUnit(row)">删除</el-button>
              </template>
            </Table>
<!--            <Page style="text-align: right;margin-top: 10px"-->
<!--                  show-sizer-->
<!--                  show-total-->
<!--                  transfer-->
<!--                  :total="dataTotal"-->
<!--                  :page-size="pageSize"-->
<!--                  :page-size-opts="pageSizeOpts"-->
<!--                  :current-page="currentPage"-->
<!--                  @on-change="pageChange"-->
<!--                  @on-page-size-change="pageSizeChange"-->
<!--            ></Page>-->
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "unitList",
  data () {
    return {
      selectUnit: 1,
      unitList: [],
      buttonProps: {
        type: 'default',
        size: 'small',
      },
      formInline: {
        user: '',
        unit: ''
      },
      ruleInline: {},
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '值班电话',
          key: 'reporter',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.workAddressBook.faxPhone)
          }
        },
        {
          title: '传真电话',
          key: 'reportTimes',
          align: 'center',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.workAddressBook.dutyTelephone)
          },
        },
        {
          title: '单位',
          key: 'reportTimes',
          align: 'center',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.unitName)
          },
        },
        {
          width: '100',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: ''
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getAllUnit()
    this.getAllUnitPhone()
    // 默认选中树形第一个
    // this.unitList[0].selected = true
  },
  methods: {
    treeChange(value){
      console.log(value)
      this.selectUnit = value[0].value
      this.getAllUnitPhone()
    },
    gotoAdd() {
      this.$router.push({
        name: 'addUnitPhone',
      })
    },
    editUnit(row) {
      this.$router.push({
        name: 'addUnitPhone',
        params: {
          row: row
        }
      })
    },
    deleteUnit(row){
      var id = parseInt(row.workAddressBook.id)
      var list = []
      list.push(id)
      this.$http.post('/api/wab/delete', list).then(res => {
        // console.log(res)
        this.getAllUnitPhone()
      })
    },
    getAllUnit(){
      this.$http.get('/api/unit/getAll').then(res => {
        // console.log(res)
        this.unitList = res.data.data
        this.unitList = this.unitList.map(item => {
          if(item.value === this.selectUnit) {
            item.selected = true
          }
          return item
        })
      })
    },
    getAllUnitPhone(){
      this.dataLoading = true
      this.$http.get(`/api/wab/getAll?id=${this.selectUnit}`).then(res => {
        // console.log(res)
        this.data = res.data.data.list
        this.dataTotal = res.data.data.total
        this.dataLoading = false
      })
    },
    pageChange(page) {
      this.currentPage = page
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
    },
  }
}
</script>

<style scoped lang="less">
.unit-list{

}
</style>
